import { Container } from "@mui/material";
import React, { useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState, useRecoilValue } from "recoil";
import AdView from "../../components/ui/AdView";
import { Ad_RefreshKey, MoveButtonState } from "../../recoil/states";
import { asyncReqBoardInfo } from "../../reducers/BoardInfoReducer";
import { AppDispatch, RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";
import $ from "jquery";

const MoveButtons = () => {
    const { MEM_UDID } = useSelector((state: RootState) => state.LoginBtnsReducer.asyncIsLogin);
    const dispatch = useDispatch<AppDispatch>();
    const [moveButtonState, setMoveButtonState] = useRecoilState(MoveButtonState);
    const ad_RefreshKey = useRecoilValue(Ad_RefreshKey);

    const isApp = navigator.userAgent.indexOf(";UGGIYO_APP;") > -1;

    // 하단 고정 바 높이에 맞춰 푸터 가림 방지
    const barRef = useRef<HTMLDivElement | null>(null);
    useLayoutEffect(() => {
        const el = barRef.current;
        if (!el) return;
        const update = () => $(".ft").css("margin-bottom", el.offsetHeight || 0);
        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);
        window.addEventListener("resize", update);
        return () => {
            ro.disconnect();
            window.removeEventListener("resize", update);
            $(".ft").css("margin-bottom", 0);
        };
    }, []);

    const handlerMoveBtn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, view_type: string) => {
        e.preventDefault();

        try {
            (window as any).videoMinAndPause?.(); // 동영상 전체화면 모드일 경우, 전체화면 해제 및 재생중지 처리
        } catch (ex) { }

        let board_seq = CommonUtil.getQuerystring("seq", "");
        if (view_type === "REFRESH") {
            // 브라우저 새로고침 처리 (장시간 사용하다보면, 버튼이 오동작하는 증상이 있어서 진짜 새로고침 처리해서 정상화 되도록 로직 보완..)
            try {
                sessionStorage.setItem("__last_move_btn_type__", moveButtonState.isClickBtnOrder ? "order" : "random");
                window.location.reload();
                return;
            } catch { }
            // 혹시라도 새로고침 예외가 발생한 경우, 소프트 새로고침 처리
            view_type = "CURR";
        } else if (view_type === "ORDER") {
            setMoveButtonState((raw) => ({ ...raw, isClickBtnOrder: true, isClickBtnRandom: false }));
            view_type = "CURR";
            board_seq = localStorage.getItem("order_seq_" + MEM_UDID) ?? "";
        } else if (view_type === "RANDOM") {
            setMoveButtonState((raw) => ({ ...raw, isClickBtnOrder: false, isClickBtnRandom: true }));
            board_seq = "";
        }
        dispatch(asyncReqBoardInfo({ view_type, board_seq }));
    };

    return (
        <>
            {/* 하단 고정 바: 광고 ▶ 버튼 순으로 세로 정렬 */}
            <div id="divFiexdRia"
                ref={barRef}
                className="bo_v_top"
                style={{
                    position: "fixed",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: "100%",
                    zIndex: 999,
                    background: "#fff",
                    borderTop: "1px solid #e0e0e0",
                    borderRadius: 0,
                    // safe-area 고려
                    padding: "5px 5px",
                    paddingBottom: "calc(5px + env(safe-area-inset-bottom, 0px))",
                    // 세로 레이아웃
                    display: isApp ? "none" : "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    boxSizing: "border-box",
                }}
            >
                {/* 광고: 가로 100% 중앙 배치 */}
                <Container maxWidth={false}
                    disableGutters
                    className="root_max_width"
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        px: 0,
                    }}>
                    <AdView
                        googleAdsense={{
                            rootid: "adsense_Ad_Web_Root_Ria",
                            slot: "3136505208",
                            height: 50,
                        }}
                        kakaoAdfit={{ rootid: "kakao_Ad_Web_Root_Ria", unit: "DAN-t4f3czp3pfe9", width: 320, height: 50 }}
                        marginStyle="0 0 5px"
                        refreshKey={ad_RefreshKey}
                    />
                </Container>

                {/* 버튼 묶음: 광고 바로 아래 중앙 정렬 */}
                <ul
                    className="bo_v_com"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                        flexWrap: "nowrap",
                    }}
                >
                    <li>
                        <a data-view-type="REFRESH" href="#none" onClick={(e) => handlerMoveBtn(e, "REFRESH")} className="btn_b01 btn">
                            <div style={{ lineHeight: "20px", padding: "3px" }}>
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                <br />
                                다시
                            </div>
                        </a>
                    </li>

                    <li style={moveButtonState.isClickBtnOrder ? {} : { display: "none" }}>
                        <a data-view-type="PREV" href="#none" onClick={(e) => handlerMoveBtn(e, "PREV")} className="btn_b01 btn">
                            <div style={{ lineHeight: "20px", padding: "3px" }}>
                                <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                <br />
                                이전
                            </div>
                        </a>
                    </li>

                    <li style={moveButtonState.isClickBtnOrder ? {} : { display: "none" }}>
                        <a data-view-type="NEW" href="#none" onClick={(e) => handlerMoveBtn(e, "NEW")} className="btn_b01 btn">
                            <div style={{ lineHeight: "20px", padding: "3px" }}>
                                <i className="fa fa-step-backward" aria-hidden="true"></i>
                                <br />
                                최신
                            </div>
                        </a>
                    </li>

                    <li>
                        <a data-view-type="RANDOM" href="#none" onClick={(e) => handlerMoveBtn(e, "RANDOM")} className="btn_b01 btn">
                            <div style={{ lineHeight: "20px", padding: "3px" }}>
                                <i className="fa fa-random" aria-hidden="true"></i>
                                <br />
                                랜덤
                            </div>
                        </a>
                    </li>

                    <li style={moveButtonState.isClickBtnRandom ? {} : { display: "none" }}>
                        <a data-view-type="ORDER" href="#none" onClick={(e) => handlerMoveBtn(e, "ORDER")} className="btn_b01 btn">
                            <div style={{ lineHeight: "20px", padding: "3px" }}>
                                <i className="fa fa-exchange" aria-hidden="true"></i>
                                <br />
                                순차
                            </div>
                        </a>
                    </li>

                    <li style={MEM_UDID !== "" && moveButtonState.isClickBtnOrder ? {} : { display: "none" }}>
                        <a data-view-type="END" href="#none" onClick={(e) => handlerMoveBtn(e, "END")} className="btn_b01 btn">
                            <div style={{ lineHeight: "20px", padding: "3px" }}>
                                <i className="fa fa-step-forward" aria-hidden="true"></i>
                                <br />
                                최종
                            </div>
                        </a>
                    </li>

                    <li style={moveButtonState.isClickBtnOrder ? {} : { display: "none" }}>
                        <a data-view-type="NEXT" href="#none" onClick={(e) => handlerMoveBtn(e, "NEXT")} className="btn_b01 btn">
                            <div style={{ lineHeight: "20px", padding: "3px" }}>
                                <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                <br />
                                다음
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default MoveButtons;
